import { FC } from 'react';

import { SaleCaseItem } from '@type-def_iqfu/public/SaleCaseItem';

import LandhousesSaleCaseTable from './LandhousesSaleCaseTable';
import LandSaleCaseTable from './LandSaleCaseTable';
import MansionSaleCaseTable from './MansionSaleCaseTable';
import styles from './SaleCaseTable.module.scss';

type Props = {
  saleCasesData: SaleCaseItem[];
  //会社詳細では会社名表示しない
  showCompanyName?: boolean;
  showPlace?: boolean;
  //マンション用テーブル、土地戸建テーブルのタイトル表示
  showTableTitle: boolean;
  readMoreButtonClicked: boolean;
  onlyLandSaleCases: boolean;
  //買取のみの場合はtrue
  onlyPurchaseSaleCases?: boolean;
  pageLabel: string;
};

const SaleCaseTable: FC<Props> = ({
  saleCasesData,
  showCompanyName = true,
  showPlace = true,
  showTableTitle = true,
  readMoreButtonClicked,
  onlyPurchaseSaleCases = false,
  onlyLandSaleCases,
  pageLabel,
}) => {
  const MansionSaleCasesData = saleCasesData.reduce((acc: SaleCaseItem[], saleCaseItem: SaleCaseItem) => {
    if (saleCaseItem.property_type === 'mansion') {
      return [...acc, saleCaseItem];
    } else {
      return acc;
    }
  }, []);

  const OtherSaleCasesData = saleCasesData.reduce((acc: SaleCaseItem[], saleCaseItem: SaleCaseItem) => {
    if (saleCaseItem.property_type !== 'mansion') {
      return [...acc, saleCaseItem];
    } else {
      return acc;
    }
  }, []);

  if (onlyLandSaleCases) {
    return (
      <LandSaleCaseTable
        saleCasesData={OtherSaleCasesData}
        showPlace={showPlace}
        pageLabel={pageLabel}
        readMoreButtonClicked={readMoreButtonClicked}
        onlyPurchaseSaleCases={onlyPurchaseSaleCases}
      />
    );
  } else {
    return (
      <div
        className={`${styles.col_stack} ${
          MansionSaleCasesData.length > OtherSaleCasesData.length ? '' : styles.reverse
        }`}
      >
        {MansionSaleCasesData.length > 0 && (
          <div>
            {showTableTitle && <h3 className={styles.property_type_title}>マンション</h3>}
            <MansionSaleCaseTable
              saleCasesData={MansionSaleCasesData}
              pageLabel={pageLabel}
              readMoreButtonClicked={readMoreButtonClicked}
              onlyPurchaseSaleCases={onlyPurchaseSaleCases}
            />
          </div>
        )}
        {OtherSaleCasesData.length > 0 && (
          <div>
            {showTableTitle && <h3 className={styles.property_type_title}>土地・戸建</h3>}
            <LandhousesSaleCaseTable
              saleCasesData={OtherSaleCasesData}
              showCompanyName={showCompanyName}
              showPlace={showPlace}
              pageLabel={pageLabel}
              readMoreButtonClicked={readMoreButtonClicked}
              onlyPurchaseSaleCases={onlyPurchaseSaleCases}
            />
          </div>
        )}
      </div>
    );
  }
};

export default SaleCaseTable;
